<p-dialog [(visible)]="showModal" [style]="{width: '75vw'}" [modal]="true" [showHeader]="false" [closable]="false"
  appendTo="body">
  <div style="position: absolute; top: 10px; right: 25px; z-index: 9999;"><a style="cursor: pointer" (click)="close()"><img
        src="./assets/images/close.svg" width="16" class="filter-invert" /></a></div>
  <div style="padding: 16px;" *ngIf="model != null">
    <div>
      <div *ngIf="showHeader && model?.orderId > 0" style="float: right; padding-right: 50px;">
        <a class="link-button" (click)="showOrder()">Show Order</a>
      </div>
      <div *ngIf="showHeader" class="medium large-text">Quote {{model?.number}}</div>
      <div *ngIf="showHeader" style="border-bottom: 1px solid #B4B4B4; padding-top:10px; margin-bottom: 10px;"></div>
    </div>

    <div class="row">
      <div class="col-6">

        <div class="medium medium-text" style="padding-top: 10px">Customer Info</div>
        <div style="border-bottom: 1px solid #B4B4B4; padding-top:10px; margin-bottom: 10px;"></div>
        <div>
          <table class="detail-table">
            <th id="quote-detail-customer-info" class="th-display-none"></th>
            <tbody>
              <tr>
                <td>{{metadata['customerBusinessName']}}</td>
                <td>
                  <dynamic-value [type]="'text'" [value]="model.customerBusinessName"></dynamic-value>
                </td>
              </tr>
              <tr>
                <td>{{metadata['customerFirstName']}}</td>
                <td>
                  <dynamic-value [type]="'text'" [value]="model.customerFirstName"></dynamic-value>
                </td>
              </tr>
              <tr>
                <td>{{metadata['customerLastName']}}</td>
                <td>
                  <dynamic-value [type]="'text'" [value]="model.customerLastName"></dynamic-value>
                </td>
              </tr>
              <tr>
                <td>{{metadata['customerAddress1']}}</td>
                <td>
                  <dynamic-value [type]="'text'" [value]="model.customerAddress1" display="block"></dynamic-value>
                  <dynamic-value [type]="'text'" [value]="model.customerCity"></dynamic-value>, <dynamic-value
                    [type]="'text'" [value]="model.customerStateCode"></dynamic-value>&nbsp;<dynamic-value
                    [type]="'zip'" [value]="model.customerZip"></dynamic-value>
                </td>
              </tr>
              <tr>
                <td>{{metadata['customerPhoneType']}}</td>
                <td>
                  <dynamic-value [type]="'lookup'" [value]="model.customerPhoneType" [items]="lookups.phoneType">
                  </dynamic-value>
                </td>
              </tr>
              <tr>
                <td>{{metadata['customerPhone']}}</td>
                <td>
                  <dynamic-value [type]="'phone'" [value]="model.customerPhone"></dynamic-value>
                </td>
              </tr>
              <tr>
                <td>{{metadata['customerEmail']}}</td>
                <td>
                  <dynamic-value [type]="'text'" [value]="model.customerEmail"></dynamic-value>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="medium medium-text" style="padding-top: 10px">Quotes &amp; Notes</div>
        <div style="border-bottom: 1px solid #B4B4B4; padding-top:10px; margin-bottom: 10px;"></div>
        <table class="detail-table">
          <tbody>
            <th id="quote-detail-quotes-note" class="th-display-none"></th>
            <tr>
              <td>{{metadata['price']}}</td>
              <td>
                <dynamic-value [type]="'currency'" [value]="model.price"></dynamic-value>
              </td>
            </tr>
            <tr>
              <td>{{metadata['specialInstructions']}}</td>
              <td>
                <dynamic-value [type]="'text'" [value]="model.specialInstructions"></dynamic-value>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <div style="padding-bottom: 5px">Notes:</div>
                <notes-detail [entityName]="'quote'" [entityId]="model.id" [showAdd]="false" [notesOnly]="true">
                </notes-detail>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
      <div class="col-6">
        <div class="medium medium-text" style="padding-top: 10px">Pickup Info</div>
        <div style="border-bottom: 1px solid #B4B4B4; padding-top:10px; margin-bottom: 10px;"></div>
        <div>
          <table class="detail-table">
            <th id="quote-detail-pickup-info" class="th-display-none"></th>
            <tbody>
              <tr>
                <td>{{metadata['customerExpectedPickup']}}</td>
                <td>
                  <dynamic-value [type]="'text'" [value]="model.customerExpectedPickup"></dynamic-value>
                </td>
              </tr>
              <tr>
                <td>{{metadata['pickupCity']}}</td>
                <td>
                  <dynamic-value [type]="'text'" [value]="model.pickupCity"></dynamic-value>
                </td>
              </tr>
              <tr>
                <td>{{metadata['pickupStateCode']}}</td>
                <td>
                  <dynamic-value [type]="'text'" [value]="model.pickupStateCode"></dynamic-value>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="medium medium-text" style="padding-top: 10px">Delivery Info</div>
        <div style="border-bottom: 1px solid #B4B4B4; padding-top:10px; margin-bottom: 10px;"></div>
        <div>
          <table class="detail-table">
            <th id="quote-detail-delivery-info" class="th-display-none"></th>
            <tbody>
              <tr>
                <td>{{metadata['customerExpectedDelivery']}}</td>
                <td>
                  <dynamic-value [type]="'text'" [value]="model.customerExpectedDelivery"></dynamic-value>
                </td>
              </tr>
              <tr>
                <td>{{metadata['deliveryCity']}}</td>
                <td>
                  <dynamic-value [type]="'text'" [value]="model.deliveryCity"></dynamic-value>
                </td>
              </tr>
              <tr>
                <td>{{metadata['deliveryState']}}</td>
                <td>
                  <dynamic-value [type]="'text'" [value]="model.deliveryState"></dynamic-value>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
